var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GoogleLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add-to-Calenar-Modal-10/2022",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-to-your-calendar-modal",
    transform: "translate(-292.000000, -208.000000)",
    fill: "#3D4548",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.500000, 87.481475)",
    id: "Save-Button"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(160.000000, 109.639752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-google-svgrepo-com",
    transform: "translate(18.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5544196,7.61303571 L17.4636161,7.22772321 L9.08879464,7.22772321 L9.08879464,10.7722768 L14.0926339,10.7722768 C13.573125,13.2392411 11.1624107,14.5378125 9.19325893,14.5378125 C7.76049107,14.5378125 6.25017857,13.9351339 5.25053571,12.9664286 C4.18535047,11.9177123 3.58110412,10.4883372 3.57107143,8.99357143 C3.57107143,7.50053571 4.24205357,6.00709821 5.21839286,5.02473214 C6.19473214,4.04236607 7.66928571,3.49272321 9.13540179,3.49272321 C10.8144643,3.49272321 12.0178125,4.38428571 12.4678125,4.79089286 L14.9866071,2.28535714 C14.2477232,1.63607143 12.2179018,0 9.05424107,0 L9.05424107,0 C6.61339286,0 4.27299107,0.934955357 2.5621875,2.64013393 C0.873883929,4.31919643 0,6.7471875 0,9 C0,11.2528125 0.826875,13.5594643 2.46294643,15.2517857 C4.21111607,17.0566071 6.68691964,18 9.23625,18 C11.5557589,18 13.7543304,17.0911607 15.3212946,15.4422321 C16.8617411,13.8190179 17.6584821,11.5730357 17.6584821,9.21857143 C17.6584821,8.22736607 17.5588393,7.63875 17.5544196,7.61303571 Z",
    id: "GoogleLogo"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/GoogleLogo.d97fa3fb29a4c0b97c9da6d7d1e336aa.svg";
export { ForwardRef as ReactComponent };